module.exports = __webpack_public_path__ + "bda51e15154a18257b4f955a222fd66f.png";


//////////////////
// WEBPACK FOOTER
// ./bower_components/datatables/media/images/sort_desc_disabled.png
// module id = 478
// module chunks = 1